export { default } from './SpreadsheetMobileDetail';
